import { PreviewsEventLogger } from 'js/file_viewer/logging/performance';
import { navigationStore, navigationAtom } from 'js/state/src/navigation/navigation_state';
export function performanceNow() {
    return typeof performance !== 'undefined' ? performance.now() : 0;
}
export async function getInitialStartTime(tags) {
    var _a;
    const { navigationTime } = navigationStore.get(navigationAtom);
    let initialStartTime = navigationTime;
    if (tags.file_flip ||
        // TODO: Track if the preview was opened as a modal
        // temporarily checking the source context to track if this was a page that opens the modal
        ['browse', 'home', 'Photos'].includes(tags.source_context)) {
        initialStartTime = ((_a = PreviewsEventLogger.getStartEntry()) === null || _a === void 0 ? void 0 : _a.startTime) || navigationTime;
    }
    return initialStartTime;
}
export async function mapApiLoggerTagsToString(tags) {
    const map = new Map();
    let tag;
    for (tag in tags) {
        if (Object.prototype.hasOwnProperty.call(tags, tag)) {
            map.set(tag, String(tags[tag]));
        }
    }
    // Add internal tags
    const { isAjaxNavigation } = navigationStore.get(navigationAtom);
    map.set('navigation_type', isAjaxNavigation || tags.file_flip ? 'ajax' : 'page_load');
    return Object.fromEntries(map.entries());
}
export const makeApiLoggerTags = (sourceContext, isLoggedIn, previewType) => {
    return {
        source_context: sourceContext,
        logged_in_user: isLoggedIn,
        preview_type: previewType,
    };
};
//# sourceMappingURL=api_logger.preenvesnextjs.map
